<template>
  <div class="footer">
    <div class="flex power-div">
      <span>Powered by:</span>
      <div class="power-by"></div>
    </div>
    <div class="copyright">Copyright©1998-{{ year }} Tencent. All Rights Reserved</div>
  </div>
</template>

<script>
const date = new Date();

export default {
  data() {
    return {
      year: date.getFullYear(),
    };
  },
  methods: {
    handleSelect() {
      this.activeIndex = '1';
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/_mixin.less';

.footer {
  color: #888;
  text-align: center;
  margin: 45px auto;
  font-size: 12px;
  .power-div {
    .justify-content(center);
    .align-items();
    margin-bottom: 15px;
    font-family: Source Han Sans CN;
  }
  .power-by {
    width: 311px;
    height: 30px;
    background-image: url(~@/assets/images/power_by.png);
    background-repeat: no-repeat;
    background-size: contain;
    margin-left: 10px;
  }
  .copyright {
    color: rgba(0, 0, 0, 0.3);
    line-height: 20px;
  }
}
</style>
